import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { AccountBalance } from '@eika-kortbetjening/types';
import { SubModal } from '@eika/modal';

import CardAccountList from '@/components/transfer/CardAccountList';
import { KortbetjeningText } from '@/hooks/use-text';
import { range } from '@/utils/array';
import { DEFAULT_APP_NAMESPACE } from '@/utils/constants/common';

import { Card } from '@generated-types';

interface Props {
    accountBalance: AccountBalance;
    id: string;
    text: KortbetjeningText;
    isLoading?: boolean;
    onChange: (card: Card) => void;
    onClose: () => void;
    loadingError: boolean;
    cardList?: Card[];
    show: boolean;
}

export const SelectAccountModal: React.FC<Props> = ({
    accountBalance,
    id,
    text,
    isLoading,
    onChange,
    onClose,
    loadingError,
    cardList,
    show,
}) => (
    <SubModal
        appNamespace={DEFAULT_APP_NAMESPACE}
        id={id}
        open={show}
        onClose={onClose}
        setOpen={onClose}
        title={!loadingError ? text.transferFromModalTitle : ''}
    >
        {isLoading ? (
            <div className="account-list-skeleton__container">
                <ul className="select-list__container">
                    {range(7).map((index) => (
                        <li className="account-list-skeleton__item" key={`account-list-skeleton-${index}`}>
                            <Skeleton height={19} />
                            <Skeleton className="account-number" width="30%" height={14} />
                        </li>
                    ))}
                </ul>
            </div>
        ) : (
            <CardAccountList
                accountBalance={accountBalance}
                text={text}
                loadingError={loadingError}
                cardList={cardList}
                onClick={onChange}
            />
        )}
    </SubModal>
);
